/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsInside: {
  name: 'arrows-inside';
  data: string;
} = {
  name: 'arrows-inside',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.707 5.707a1 1 0 0 0-1.414-1.414L15 7.586V5a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2h-2.586l3.293-3.293ZM5 13a1 1 0 1 0 0 2h2.586l-3.293 3.293a1 1 0 1 0 1.414 1.414L9 16.414V19a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1H5Z" fill="currentColor"/></svg>`,
};
